import TeamProductivityReducer from './TeamProductivityReducer';
import { UserDetailStatisticReducers } from './containers/UserDetailStatistic';

export default from './TeamProductivityContainer';
export const TeamProductivityReducers = {
  TeamProductivityReducer,
  ...UserDetailStatisticReducers,
};
